export const HISTORIC_ONLY: string = 'HistoricOnly'
export const INTEGRATION_MODE: string = 'IntegrationMode'
export const INTEGRATION_TYPE: string = 'IntegrationType'
export const INTEGRATION_MODE_OPTIONS: string = 'IntegrationModeOptions'
export const PARTITION_LICENCES: string = 'PartitionLicences'
export const TELSYS_TYPE: string = 'TelSysType'
export const MONITORING_ENABLED: string = 'MonitoringEnabled'
export const BOTS_DISABLED: string = 'BotsDisabled'
export const COMMS_ENABLED: string = 'CommsEnabled'
export const AUTH_USER_MISSING_ROLES: string = 'AuthUserMissingRoles'
export const MANUAL_RT_QUEUE_ENABLED: string = 'ManualRTQueuesEnabled'
export const CALL_RECORDING_DEFAULTS: string = 'CallRecIntIDDefault'
export const CALL_CONTROL_OPTIONS: string = 'CallControlOptions'
export const LICENCE_LEVEL: string = 'LicenceLevel'

export const ADVANCED_FIELDS = {
    MAXIMUM_ALLOWED_USERS_MONITORED: 'MaximumAllowedUsersMonitored'
}
